'use client';

import React from 'react';
import Link from 'next/link';
import styles from './SidebarLayout.module.css';


import {
  Home,
  Heart,
  ListMusic,
  History,
} from 'lucide-react';

interface SidebarLayoutProps {
  children?: React.ReactNode; // 👈 теперь опционально
}


export default function SidebarLayout({ children }: SidebarLayoutProps) {
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <nav className={styles.nav}>
          <Link href="/" className={styles.navItem}>
            <Home size={20} className={styles.icon} />
            Home
          </Link>

          <Link href="/library/favorites" className={styles.navItem}>
            <Heart size={20} className={styles.icon} />
            Favorites
          </Link>

          <Link href="/library/playlists" className={styles.navItem}>
            <ListMusic size={20} className={styles.icon} />
            Playlists
          </Link>

          <Link href="/library/history" className={styles.navItem}>
            <History size={20} className={styles.icon} />
            History
          </Link>
        </nav>
      </aside>

      <main className={styles.mainContent}>
        {children}
      </main>
    </div>
  );
}
